import React from "react"
import { makeStyles } from "@material-ui/core/styles/index"
import { Container, Grid } from "@material-ui/core/index"
import Button from "@material-ui/core/Button"
import { injectIntl, Link } from "gatsby-plugin-intl"
import LineTitle from "./LineTitle"
import BackgroundImage from "gatsby-background-image"
// import Images from "../styles/Images"
import AboutUsCard from "./Cards/AboutUsCard"
import ExpansionPanel from "@material-ui/core/ExpansionPanel"
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary"
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
// import { CardActions } from "@material-ui/core"
import Img from "gatsby-image"
import Typography from "@material-ui/core/Typography"

const useStyles = makeStyles((theme) => ({
  bannerRight: {
    display: "flex",
    justifyContent: "flex-end",
  },
  mainContainer: {
    padding: "0 !important",
    overflowX: "hidden",
  },
  container: {
    backgroundColor: "transparent",
  },
  bannerGrid: {
    flexDirection: "row",
    alignItems: "center",
    position: "relative",
    zIndex: 2,
    minHeight: "600px",
    ["@media (min-width:1280px)"]: {
      minHeight: "700px",
    },
    ["@media (min-width:1600px)"]: {
      minHeight: "820px",
    },
    ["@media (min-width:1920px)"]: {
      minHeight: "880px",
    },
    ["@media (max-width:600px)"]: {
      minHeight: "480px",
      paddingBottom: "60px",
    },
  },
  heroOverlay: {
    display: "none",
    ["@media (max-width:600px)"]: {
      display: "block",
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.65)",
      pointerEvents: "none",
      zIndex: 1,
    },
  },
  heroWrap: {
    background: "linear-gradient(to right, #AAB5A8, #E0E3E0)",
    position: "relative",
    "&:before": {
      opacity: "0 !important",
    },
    "&:after": {
      opacity: "0 !important",
    },
    ["@media (max-width:600px)"]: {
      "&:after": {
        opacity: "1 !important",
        backgroundSize: "cover !important",
        backgroundPosition: "60% center !important",
        transform: "scaleX(-1)",
      },
    },
  },
  docs: {
    minWidth: "100%",
    justifyContent: "flex-end",
    maxHeight: 600,
    ["@media (max-width:600px)"]: {
      display: "none",
    },
  },
  docMobile: {
    ["@media (min-width:600px)"]: {
      display: "none",
    },
  },

  tooLongtitle: {
    fontWeight: 400,
    ["@media (max-width:600px)"]: {
      fontSize: "2.4rem",
    },
  },
  tooLongSubheader: {
    color: "white",
    textTransform: "uppercase",
    align: "left",
    marginTop: "20px",
    maxWidth: "550px",
    ["@media (max-width:600px)"]: {
      fontSize: "1.3rem",
    },
  },
  pageTitle: {
    paddingTop: "80px",
  },
  heroTitleContainer: {
    paddingTop: "0 !important",
    paddingBottom: "0 !important",
  },
  heroTitleColumn: {
    ["@media (max-width:600px)"]: {
      display: "flex !important",
      alignItems: "center !important",
      minHeight: "480px",
    },
  },
  aboutUs: {
    padding: "0 !important",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingBottom: "120px",
    backgroundColor: "#202020",
    paddingTop: "40px",
  },
  moreButton: {
    paddingLeft: "3px",
    maxWidth: "160px",
    "&:hover": {
      backgroundColor: "rgba(220,220,220,0)",
    },
  },
  expansion: {
    backgroundColor: "transparent!important",
    boxShadow: "none!important",
    border: "none!important",
    "&:before": {
      display: "none!important",
    },
  },
  expansionDetails: {
    padding: "0px",
    color: "rgba(0, 0, 0, 0.54)",
  },
  contentSummary: {
    color: "rgba(0, 0, 0, 0.54)",
  },
  imageHarvard: {
    marginTop: 20,
    width: "180px",
    height: "120px",
  },
  honorText: {
    fontSize: "0.8rem",
    paddingTop: 20,
  },
  instituteSection: {
    backgroundColor: "#202020",
    width: "100%",
    padding: "100px 5% 40px",
    margin: 0,
    [theme.breakpoints.down("sm")]: {
      padding: "60px 20px 0",
    },
  },
  instituteGrid: {
    maxWidth: "1200px",
    margin: "0 auto",
    alignItems: "center",
  },
  instituteImageCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  instituteImageWrap: {
    width: "100%",
    maxWidth: "560px",
    [theme.breakpoints.down("sm")]: {
      width: "calc(100% + 88px)",
      maxWidth: "calc(100% + 88px)",
      marginLeft: "-44px",
      marginRight: "-44px",
      marginBottom: "8px",
    },
  },
  instituteImage: {
    width: "100%",
    borderRadius: "4px",
    [theme.breakpoints.down("sm")]: {
      borderRadius: 0,
    },
  },
  instituteTextCol: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    textAlign: "left",
    maxWidth: "560px",
  },
  instituteLabel: {
    color: "silver",
    textTransform: "uppercase",
    letterSpacing: "0.15em",
    fontSize: "0.9rem",
    fontWeight: 500,
    marginBottom: "16px",
  },
  instituteTitle: {
    color: "white",
    fontWeight: 300,
    marginBottom: "20px",
    textAlign: "left",
  },
  instituteText: {
    fontSize: "1.1rem",
    color: "white",
    margin: 0,
    marginBottom: "40px",
    lineHeight: 1.6,
    maxWidth: "560px",
  },
  instituteCtaLink: {
    display: "inline-block",
    textDecoration: "none",
  },
  instituteCta: {
    color: "white!important",
    fontSize: "14px!important",
    fontWeight: "bold",
    backgroundColor: "transparent",
    border: "2px solid white",
    borderRadius: "40px!important",
    padding: "0.8em 2.5em!important",
    textDecoration: "none!important",
    "&:hover": {
      textDecoration: "none!important",
      opacity: "0.7!important",
      backgroundColor: "transparent!important",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0.8em 1.5em!important",
    },
  },
}))

const About = ({
  intl,
  bannerImg,
  img1,
  img2,
  img3,
  hadeHonor,
  callumHonorHarvard,
  callumHonorTeaching,
  callumExamen,
  instituteImage,
}) => {
  const classes = useStyles()
  const aboutUsCardData = [
    {
      name: intl.formatMessage({ id: "about.susan.name" }),
      title: intl.formatMessage({ id: "about.susan.title" }),
      img: img1,
      iconName: "fillersStripe",
      instagram: "drsusanschmidt",
      text: (
        <p style={{ whiteSpace: "pre-line" }}>
          {intl.formatMessage({ id: "about.susan.description" })}
        </p>
      ),
      id: "susan",
    },
    {
      name: "Callum Faris",
      title: intl.formatMessage({ id: "about.callum.title" }),
      subTitle: intl.formatMessage({ id: "about.callum.subtitle" }),
      img: img2,
      iconName: "faceLiftStripe",
      instagram: "doctor.callum.faris",
      text: (
        <p style={{ whiteSpace: "pre-line" }}>
          {intl.formatMessage({ id: "about.callum.description" })}
        </p>
      ),
      // moreText: (
      //   <p style={{ whiteSpace: "pre-line" }}>
      //     {intl.formatMessage({ id: "about.callum.readMore" })}
      //   </p>
      // ),
      // honorCallum: (
      //   <>
      //     <br />
      //     <Typography
      //       component="h4"
      //       variant="p"
      //       className={classes.titleAchieve}
      //     >
      //       Achievements
      //     </Typography>
      //     <br />
      //     <Img
      //       fluid={callumHonorHarvard}
      //       className={classes.imageHarvard}
      //       alt={"certificate"}
      //     ></Img>
      //     <Typography
      //       component="p"
      //       variant="p"
      //       className={classes.honorText}
      //       color="textSecondary"
      //     >
      //       Department of Otolaryngology Harvard Medical School - Callum Faris,
      //       M.D. has fulfilled the requirements of professional training as
      //       Clinical Fellow in Facial Plastic and Reconstructive Surgery
      //     </Typography>
      //     <br />
      //     <Img
      //       fluid={callumHonorTeaching}
      //       className={classes.imageHarvard}
      //       alt={"certificate"}
      //     ></Img>
      //     <Typography
      //       component="p"
      //       variant="p"
      //       className={classes.honorText}
      //       color="textSecondary"
      //     >
      //       Award of Excellence in Teaching - Harvard Medical
      //       School/Massachusets Eye and Ear - Training Program in Otolaryngology
      //       - Head and Neck Surgery - award this certificate of appreciation to
      //       - Callum Faris, M.D. for excellence in teaching and mentorship of
      //       recidents
      //     </Typography>
      //     <br />
      //     <Img
      //       fluid={callumExamen}
      //       className={classes.imageHarvard}
      //       alt={"certificate"}
      //     ></Img>
      //     <Typography
      //       component="p"
      //       variant="p"
      //       className={classes.honorText}
      //       color="textSecondary"
      //     >
      //       The International Board For Certification in Facial Plastic and
      //       Reconstructive Surgery - Claus D. Walter, M.D. Award for Academic
      //       Excellence to - Callum Faris, M.D. for Achieving the Highest score
      //       Among the International Candidates on the 2013 Certifying
      //       Examination
      //     </Typography>
      //     <br />
      //   </>
      // ),
      honor2: true,
      callumHonorHarvard: callumHonorHarvard,
      callumHonorTeaching: callumHonorTeaching,
      callumExamen: callumExamen,
      id: "callum",
    },
    // {
    //   name: "Hade Vuyk",
    //   title: intl.formatMessage({ id: "about.hade.title" }),
    //   img: img3,
    //   iconName: "correctiveStripe",
    //   text: (
    //     <p style={{ whiteSpace: "pre-line" }}>
    //       {intl.formatMessage({ id: "about.hade.description" })}
    //     </p>
    //   ),
    //   id: "hade",
    //   honor1: hadeHonor,
    //   honorText1:
    //     "Medal of honor awarded by the Dutch Specialists Association for Throat, Nose, Ear Surgery and Surgery of the Head, Neck area for its Personal Commitment, Education and High Quality in Plastic and Reconstructive Facial Surgery. November 2016.",
    // },
  ]
  return (
    <Container maxWidth={"xl"} className={classes.mainContainer}>
      <BackgroundImage
        fluid={bannerImg}
        className={classes.heroWrap}
        backgroundColor={`#AAB5A8`}
      >
        <div className={classes.heroOverlay} aria-hidden="true" />
        <Grid container spacing={0} className={classes.bannerGrid}>
          <Grid item xs={12} sm={6} className={classes.heroTitleColumn}>
            <Container>
              <LineTitle
                header={intl.formatMessage({ id: "about.title" })}
                subheader={intl.formatMessage({ id: "about.subHeaderTitle" })}
                titleContainer={classes.heroTitleContainer}
                titleStyle={classes.tooLongtitle}
                subHeaderStyle={classes.tooLongSubheader}
              />
            </Container>
          </Grid>
          <Grid item xs={12} sm={6} className={classes.bannerRight}>
            <Img
              fluid={bannerImg}
              alt={intl.formatMessage({ id: "about.doctor" })}
              className={classes.docs}
            />
          </Grid>
        </Grid>
      </BackgroundImage>
      {/* Hidden until /about-face-institute is officially released.
      <section className={classes.instituteSection}>
        <Grid container spacing={6} className={classes.instituteGrid}>
          <Grid item xs={12} md={6} className={classes.instituteImageCol}>
            <div className={classes.instituteImageWrap}>
              <Img
                fluid={instituteImage}
                alt={intl.formatMessage({ id: "about.institute.title" })}
                className={classes.instituteImage}
                imgStyle={{ borderRadius: "inherit" }}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className={classes.instituteTextCol}>
              <Typography className={classes.instituteLabel}>
                {intl.formatMessage({ id: "about.institute.label" })}
              </Typography>
              <Typography
                component="h2"
                variant="h3"
                className={classes.instituteTitle}
              >
                {intl.formatMessage({ id: "about.institute.title" })}
              </Typography>
              <p className={classes.instituteText}>
                {intl.formatMessage({ id: "about.institute.text" })}
              </p>
              <Link to="/about-face-institute" className={classes.instituteCtaLink}>
                <Button className={classes.instituteCta}>
                  {intl.formatMessage({ id: "about.institute.cta" })}
                </Button>
              </Link>
            </div>
          </Grid>
        </Grid>
      </section>
      */}
      <Container maxWidth={"xl"} className={classes.cardContainer}>
        <Container maxWidth={"xl"} className={classes.aboutUs}>
          {aboutUsCardData.map((card) => (
            <AboutUsCard
              name={card.name}
              title={card.title}
              subTitle={card.subTitle}
              instagram={card.instagram}
              iconName={card.iconName}
              img={card.img}
              key={card.title}
              id={card.id}
              honor1={card.honor1}
              honorText1={card.honorText1}
              honor2={card.honor2}
              callumHonorHarvard={callumHonorHarvard}
              callumHonorTeaching={callumHonorTeaching}
              callumExamen={callumExamen}
            >
              {card.text}
              {card.moreText && (
                <ExpansionPanel
                  classes={{
                    root: classes.expansion,
                  }}
                >
                  <ExpansionPanelSummary
                    classes={{
                      content: classes.contentSummary,
                      root: classes.rootSummary,
                    }}
                    className={classes.moreButton}
                    expandIcon={
                      <ExpandMoreIcon className={classes.arrowDown} />
                    }
                  >
                    Read more
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails className={classes.expansionDetails}>
                    {/* <Grid>
                      <Grid item>{card.moreText}</Grid>
                      <Grid item>{card.honorCallum}</Grid>
                    </Grid> */}
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              )}
            </AboutUsCard>
          ))}
        </Container>
      </Container>
    </Container>
  )
}

export default injectIntl(About)
